import s from '@/styles/components/Grid.module.scss'
import { ForwardedRef, forwardRef, HTMLAttributes, PropsWithChildren } from 'react'
import { classNames } from '@tmap-web-lib/utils'
import parse from 'html-react-parser'

interface Props extends PropsWithChildren, Omit<HTMLAttributes<HTMLElement>, 'title'> {
  title?: string;
  description?: string;
  descriptionSize?: 'small' | 'medium' | 'large';
  isNoPadding?: boolean;
}

const Grid = forwardRef((props: Props, ref?: ForwardedRef<HTMLElement>) => {
  const {
    id,
    title,
    description,
    descriptionSize,
    isNoPadding,
    style,
    children,
  } = props

  return (
    <section
      ref={ref}
      id={id}
      className={classNames(s.wrap, isNoPadding ? s.no_padding : undefined)}
      style={style}
    >
      {title && <h2 className={s.title}>{parse(title)}</h2>}
      {description && <p className={s.description} data-size={descriptionSize}>{description}</p>}
      {children}
    </section>
  )
})

Grid.displayName = 'Grid'
export { Grid }
